export class Errors {

	constructor() {
		this.errors = {};
		this.empty = true;
	}

	get(field) {
		if (this.errors[field]) {
			return this.errors[field][0];
		}
	}

	check(field) {
		return this.errors[field] ? true : false
	}

	record(errors) {
		this.errors = errors;
		this.empty = false
	}

	clear(field) {
		delete this.errors[field]
		if (this.isEmpty(this.errors)) {
			this.empty = true
		}
	}

	reset() {
		this.errors = {}
		this.empty = true
	}

	isEmpty(obj) {
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}
		return true;
	}

}
